import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-ils-not-found',
  templateUrl: './ils-not-found.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./ils-not-found.component.scss'],
})
export class IlsNotFoundComponent {}
